import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { __TOPONYMY_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ListItemType } from 'shell/models/item-type';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface CivicTypeProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
}

const CivicTypeComponent = ({ disabled, onChange, value }: CivicTypeProps): React.ReactElement => {
  const {
    data,
    error,
    get: getCivicTypes,
  } = useHttpFetch<HttpResponseList<ListItemType>>(
    `${__TOPONYMY_API_URL__}/areaCircolazione/civico/tipo/tipologia-abitazione`,
    {
      data: {
        payload: {
          list: [],
        },
      },
    }
  );

  const civicTypes: Array<ItemVM> = useMemo(() => {
    if (!!error || !data?.payload) {
      return [];
    }
    return data?.payload.list.map((civicType) => ({
      id: civicType.key,
      value: civicType.descrizione,
    }));
  }, [data, error]);

  useEffect(() => {
    getCivicTypes();
  }, []);

  return (
    <PmiFormControl fullWidth>
      <InputLabel id="civicState-label" disabled={disabled}>
        Tipologia Civico
      </InputLabel>
      <PmiSelect
        labelId="civicType-label"
        id="civicType"
        name="civicType"
        value={value}
        label="Tipologia Civico"
        onChange={onChange}
        disabled={disabled}
      >
        <MenuItem value="">&nbsp;</MenuItem>
        {(civicTypes || [])?.map((civicType: ItemVM) => (
          <MenuItem key={civicType.id} value={civicType.id}>
            {civicType.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

CivicTypeComponent.displayName = 'Civic type component';

const CivicType = memo(CivicTypeComponent);

export default CivicType as typeof CivicTypeComponent;
